import { useMutation, useQueryClient } from "@tanstack/react-query";
import { upsertLangValue } from "../../utils/iriLast";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePutCatalog({ callApiWithWorker, t }) {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["datasetOffers"],
    mutationFn: async ({ offerId, offer, lang, title, description }) => {
      const payload = {
        title: upsertLangValue(offer?.title, lang, title),
        description: upsertLangValue(offer?.description, lang, description),
      };
      const res = await callApiWithWorker(`/dataset-offers/${offerId}`, {
        method: "PUT",
        body: payload,
      });

      const status =
        res?.statusCode ??
        res?.status ??
        res?.data?.statusCode ??
        res?.data?.status;
      if (status && status >= 400) throw new Error(`Update failed (${status})`);

      const body =
        typeof res?.body === "string"
          ? JSON.parse(res.body)
          : (res?.data ?? res);
      return body;
    },
    onSuccess: async (updated, vars) => {
      qc.setQueryData(["datasetOffers", vars.offerId], (prev) => ({
        ...prev,
        ...updated,
      }));

      await qc.invalidateQueries({ queryKey: ["datasetOffers"] });
      await qc.invalidateQueries({ queryKey: ["datasetOfferings"] });

      showSuccessToast(t("updateSubMessage"), {
        title: t("updateMessage"),
      });
    },
    onError: (error) => {
      showErrorAlert(error);
    },
  });
}
